import { h } from 'preact';
export function Hoverable(props) {
    return (h("span", { class: `primer-spec-hoverable ${props.floatRight ? 'primer-spec-hoverable-float-right' : ''}` }, props.children));
}
